
import GenomeSidebarPanel   from './GenomeSidebarPanel';
import React                from 'react';
import ReactDOM             from 'react-dom';
import TagModel             from '_legacy-models/TagModel';
import UiHelper             from '_utils/UiHelper';

const genomeSidebar = {

  panel2: {
    heading: '',
    headingPath: '',
    tags: [],
    parentTagId: null,
    isInitiallyCollapsed: false,
    isOpen: false,
    isLoading: false,
    isFrozen: false,
    hasSeoTags: false,
    shouldAnimateAppearance: false,
    onAppear: null,
    onClose: null,
    onCollapse: null
  },

  panel3: {
    heading: '',
    headingPath: '',
    tags: [],
    parentTagId: null,
    isInitiallyCollapsed: false,
    isOpen: false,
    isLoading: false,
    isFrozen: false,
    hasSeoTags: false,
    shouldAnimateAppearance: false,
    onAppear: null,
    onClose: null,
    onCollapse: null
  },

  panel4: {
    heading: '',
    headingPath: '',
    tags: [],
    parentTagId: null,
    isInitiallyCollapsed: false,
    isOpen: false,
    isLoading: false,
    isFrozen: false,
    hasSeoTags: false,
    shouldAnimateAppearance: false,
    onAppear: null,
    onClose: null,
    onCollapse: null
  },

  state: {
    isFrozen: false
  },

  init: function() {
    this.Tag = new TagModel;

    // search toggle
    const searchToggle = document.querySelector('.genome-sidebar .genome-search-toggle');
    if (searchToggle) {
      searchToggle.addEventListener("click", (e) => {
        this.handleSearchToggleClick(e);
      });
    }

    // Tags
    const tags = document.querySelectorAll('.genome-sidebar .non-react .genome-sidebar-panel .tags-list .tag');
    if (tags && tags.length > 0) {
      tags.forEach((tag, index) => {
        tag.addEventListener("click", (e) => {
          this.handleTagClick(e);
        });
      });
    }

    // Panel 1 Tags
    const panel1Tags = document.querySelectorAll('.genome-sidebar .panel-1.non-react .genome-sidebar-panel .tags-list .tag');
    if (panel1Tags && panel1Tags.length > 0) {
      panel1Tags.forEach((tag, index) => {
        UiHelper.onLinger(tag, (e) => {
          this.handlePanel1TagLinger(e);
        });
      });
    }

    // Panel 2 Tags
    const panel2Tags = document.querySelectorAll('.genome-sidebar .panel-2.non-react .genome-sidebar-panel .tags-list .tag');
    if (panel2Tags && panel2Tags.length > 0) {
      panel2Tags.forEach((tag, index) => {
        if (tag.classList.contains('branch')) {
          UiHelper.onLinger(tag, (e) => {
            this.handlePanel2TagLinger(e);
          });
        }
      });
    }

    // Panel 3 Tags
    const panel3Tags = document.querySelectorAll('.genome-sidebar .panel-3.non-react .genome-sidebar-panel .tags-list .tag');
    if (panel3Tags && panel3Tags.length > 0) {
      panel3Tags.forEach((tag, index) => {
        if (tag.classList.contains('branch')) {
          UiHelper.onLinger(tag, (e) => {
            this.handlePanel3TagLinger(e);
          });
        }
      });
    }

    // Javascript tag links (non-SEO centric links)
    const jsTagLinks = document.querySelectorAll('.genome-sidebar .non-react .genome-sidebar-panel .tags-list .tag .tag-js-link');
    if (jsTagLinks && jsTagLinks.length > 0) {
      jsTagLinks.forEach((jsTagLink, index) => {
        jsTagLink.addEventListener("click", (e) => {
          this.handleJsTagLinkClick(e);
        });
      });
    }

    // sidebar
    const sidebar = document.querySelector('.genome-sidebar');
    if (sidebar) {
      sidebar.addEventListener("mouseleave", (e) => {
        this.handleSidebarMouseleave(e);
      });
    }
  },

  renderGenomeSidebarPanel2: function(opts) {
    this.panel2 = {...this.panel2, ...opts};

    const panel2Container = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-2.react');

    ReactDOM.render(
      <GenomeSidebarPanel
        key="panel2"
        panel={2}
        heading={this.panel2.heading}
        headingPath={this.panel2.headingPath}
        tags={this.panel2.tags}
        isInitiallyCollapsed={this.panel2.isInitiallyCollapsed}
        isOpen={this.panel2.isOpen}
        isLoading={this.panel2.isLoading}
        hasSeoTags={this.panel2.hasSeoTags}
        shouldAnimateAppearance={this.panel2.shouldAnimateAppearance}
        onAppear={this.panel2.onAppear}
        onClose={this.panel2.onClose}
        onCollapse={this.panel2.onCollapse}
      />, panel2Container
    );
  },

  renderGenomeSidebarPanel3: function(opts) {
    this.panel3 = {...this.panel3, ...opts};

    const panel3Container = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.react');

    ReactDOM.render(
      <GenomeSidebarPanel
        key="panel3"
        panel={3}
        heading={this.panel3.heading}
        headingPath={this.panel3.headingPath}
        tags={this.panel3.tags}
        isInitiallyCollapsed={this.panel3.isInitiallyCollapsed}
        isOpen={this.panel3.isOpen}
        isLoading={this.panel3.isLoading}
        hasSeoTags={this.panel3.hasSeoTags}
        shouldAnimateAppearance={this.panel3.shouldAnimateAppearance}
        onAppear={this.panel3.onAppear}
        onClose={this.panel3.onClose}
        onCollapse={this.panel3.onCollapse}
      />, panel3Container
    );
  },

  renderGenomeSidebarPanel4: function(opts) {
    this.panel4 = {...this.panel4, ...opts};

    const panel4Container = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react');

    ReactDOM.render(
      <GenomeSidebarPanel
        key="panel4"
        panel={4}
        heading={this.panel4.heading}
        headingPath={this.panel4.headingPath}
        tags={this.panel4.tags}
        isInitiallyCollapsed={this.panel4.isInitiallyCollapsed}
        isOpen={this.panel4.isOpen}
        isLoading={this.panel4.isLoading}
        hasSeoTags={this.panel4.hasSeoTags}
        shouldAnimateAppearance={this.panel4.shouldAnimateAppearance}
        onAppear={this.panel4.onAppear}
        onClose={this.panel4.onClose}
        onCollapse={this.panel4.onCollapse}
      />, panel4Container
    );
  },

  handleSearchToggleClick: function(e) {
    const body = document.querySelector('body');
    body.classList.add('show-search-bar');
  },

  handleTagClick: function(e) {
    this.freezeSidebar();

    const contentBlock = document.querySelector('.genome-page .genome-page-content');
    contentBlock.classList.add('is-loading');
    const panelContainer = e.target.closest('.panel-container');
    const tagLevel = panelContainer.getAttribute('data-level');

    this.renderGenomeSidebarPanel2({
      isOpen: false
    });
  },

  handleJsTagLinkClick(e, tag) {
    e.stopPropagation();
    this.freezeSidebar();
    location.href = e.target.getAttribute('data-path');
  },

  handlePanel1TagLinger: function(e) {
    if (this.state.isFrozen) {
      return false;
    }

    const panel2 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-2.non-react .genome-sidebar-panel');
    const panel3 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.non-react .genome-sidebar-panel');
    const panel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.non-react .genome-sidebar-panel');
    const reactPanel3 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.react .genome-sidebar-panel');
    const reactPanel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react .genome-sidebar-panel');

    const parentTagLink = e.target.querySelector('.tag-link');
    const parentTagName = parentTagLink.innerText;
    const parentTagPath = parentTagLink.getAttribute('data-path');
    const parentTagKey = parentTagLink.getAttribute('data-key');
    const parentTagId = parentTagLink.getAttribute('data-id');

    this.panel2.parentTagId = parentTagId;

    this.renderGenomeSidebarPanel2({
      heading: parentTagName,
      headingPath: parentTagPath,
      tags: [],
      isOpen: (panel2) ? true : false,
      isLoading: true,
      shouldAnimateAppearance: true,
      onAppear: () => {
        this.renderGenomeSidebarPanel2({
          isOpen: true,
          isLoading: (this.panel2.tags.length == 0) ? true : false
        });
      },
      onClose: () => {
        this.renderGenomeSidebarPanel2({
          isOpen: false
        });
      },
    });

    if (panel3) {
      panel3.classList.remove('is-open');
      panel3.classList.add('is-closed');
    }

    // close react panel 3 if it exists
    if (reactPanel3) {
      this.renderGenomeSidebarPanel3({
        isOpen: false
      });
    }

    if (panel4) {
      panel4.classList.remove('is-open');
      panel4.classList.add('is-closed');
    }

    // close react panel 4 if it exists
    if (reactPanel4) {
      this.renderGenomeSidebarPanel4({
        isOpen: false
      });
    }

    this.getTagChildren(parentTagId, (requestParentTagId, childTags) => {
      // check to make sure that the data being handled by this callback
      // is the data for the tag most recently moused over. If the parentTagId
      // for this data does not match the most recently moused over parentTag,
      // drop the data (this flattens cases where old data takes longer than newer
      // data to arrive)

      if (requestParentTagId != this.panel2.parentTagId) {
        return null;
      }

      if (this.state.isFrozen) {
        return null;
      }

      this.renderGenomeSidebarPanel2({
        heading: parentTagName,
        headingPath: parentTagPath,
        tags: childTags,
        isOpen: true,
        isLoading: false
      });
    });
  },

  handlePanel2TagLinger: function(e) {
    // TODO: Fold both handlePanel1TagLinger and handlePanel2TagLinger into a single handler
    if (this.state.isFrozen) {
      return false;
    }

    const reactPanel3 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.react .genome-sidebar-panel');
    const panel3 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.non-react .genome-sidebar-panel');
    const reactPanel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react .genome-sidebar-panel');
    const panel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.non-react .genome-sidebar-panel');

    const parentTagLink = e.target.querySelector('.tag-link');
    const parentTagName = parentTagLink.innerText;
    const parentTagPath = parentTagLink.getAttribute('data-path');
    const parentTagKey = parentTagLink.getAttribute('data-key');
    const parentTagId = parentTagLink.getAttribute('data-id');

    this.panel3.parentTagId = parentTagId;

    this.renderGenomeSidebarPanel3({
      heading: parentTagName,
      headingPath: parentTagPath,
      tags: [],
      isOpen: (reactPanel3) ? true : false,
      isLoading: true,
      shouldAnimateAppearance: true,
      onAppear: () => {
        this.renderGenomeSidebarPanel3({
          isOpen: true,
          isLoading: (this.panel3.tags.length == 0) ? true : false
        });
      },
      onClose: () => {
        this.renderGenomeSidebarPanel3({
          isOpen: false
        });
      },
    });

    this.getTagChildren(parentTagId, (requestParentTagId, childTags) => {
      // see note above in handlePanel1TagLinger getTagChildren call

      if (requestParentTagId != this.panel3.parentTagId) {
        return null;
      }

      this.renderGenomeSidebarPanel3({
        heading: parentTagName,
        headingPath: parentTagPath,
        tags: childTags,
        isOpen: true,
        isLoading: false
      });
    });
  },

  handlePanel3TagLinger: function(e) {
    if (this.state.isFrozen) {
      return false;
    }

    const reactPanel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react .genome-sidebar-panel');
    const panel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.non-react .genome-sidebar-panel');

    const parentTagLink = e.target.querySelector('.tag-link');
    const parentTagName = parentTagLink.innerText;
    const parentTagPath = parentTagLink.getAttribute('data-path');
    const parentTagKey = parentTagLink.getAttribute('data-key');
    const parentTagId = parentTagLink.getAttribute('data-id');

    this.panel4.parentTagId = parentTagId;

    this.renderGenomeSidebarPanel4({
      heading: parentTagName,
      headingPath: parentTagPath,
      tags: [],
      isOpen: (reactPanel4) ? true : false,
      isLoading: true,
      shouldAnimateAppearance: true,
      onAppear: () => {
        this.renderGenomeSidebarPanel4({
          isOpen: true,
          isLoading: (this.panel4.tags.length == 0) ? true : false
        });
      },
      onClose: () => {
        this.renderGenomeSidebarPanel4({
          isOpen: false
        });
      },
    });

    this.getTagChildren(parentTagId, (requestParentTagId, childTags) => {
      // see note above in handlePanel1TagLinger getTagChildren call

      if (requestParentTagId != this.panel4.parentTagId) {
        return null;
      }

      this.renderGenomeSidebarPanel4({
        heading: parentTagName,
        headingPath: parentTagPath,
        tags: childTags,
        isOpen: true,
        isLoading: false
      });
    });
  },

  handleSidebarMouseleave: function(e) {
    if (this.state.isFrozen) {
      return false;
    }

    const reactPanel2 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-2.react .genome-sidebar-panel');
    const reactPanel3 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.react .genome-sidebar-panel');
    const reactPanel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react .genome-sidebar-panel');
    const panel2 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-2.non-react .genome-sidebar-panel');
    const panel3 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.non-react .genome-sidebar-panel');
    const panel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.non-react .genome-sidebar-panel');

    if (reactPanel2) {
      this.renderGenomeSidebarPanel2({
        isOpen: false
      });
    }

    if (reactPanel3) {
      this.renderGenomeSidebarPanel3({
        isOpen: false
      });
    }

    if (reactPanel4) {
      this.renderGenomeSidebarPanel4({
        isOpen: false
      });
    }

    if (panel2) {
      panel2.classList.remove('is-closed');
      panel2.classList.add('is-open');
    }

    if (panel3) {
      panel3.classList.remove('is-closed');
      panel3.classList.add('is-open');
    }

    if (panel4) {
      panel4.classList.remove('is-closed');
      panel4.classList.add('is-open');
    }
  },

  getTagChildren: function(tagId, callback) {
    this.Tag.children({
      tagId: tagId,
      done: (data) => {
        console.log('in getTagChildren done block, data:', data);
        if (callback) {
          callback(tagId, data);
        }
      },
      fail: (message) => {
        console.log ('something went wrong in Tag.children. message:', message);
      }
    });
  },

  freezeSidebar: function() {
    this.state.isFrozen = true;

    this.renderGenomeSidebarPanel2({
      isFrozen: true,
    });

    this.renderGenomeSidebarPanel3({
      isFrozen: true,
    });

    this.renderGenomeSidebarPanel4({
      isFrozen: true,
    });
  }
};

export default genomeSidebar;
